// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"285":"b4133208","2097":"8c724200","7990":"8c724200"}[chunkId] + ".chunk.css";
};